module.exports = __webpack_public_path__ + "img/17.48a173c9.png";